
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { DeviceType, AppModule } from '@/store/modules/app'
import { AppMain, Navbar, Sidebar, Warning } from './components'
import ResizeMixin from './mixin/resize'

@Component({
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
    Warning
  }
})
export default class extends mixins(ResizeMixin) {
  private warningHeight = 32
  get classObj() {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation,
      mobile: this.device === DeviceType.Mobile
    }
  }

  mounted() {
    this.updateWarningHeight()
    window.addEventListener('resize', this.updateWarningHeight)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updateWarningHeight)
  }

  private updateWarningHeight() {
    this.$nextTick(() => {
      const warningEl = this.$refs.warningComponent as any
      if (warningEl && warningEl.$el) {
        this.warningHeight = warningEl.$el.offsetHeight
        document.documentElement.style.setProperty('--warning-height', `${this.warningHeight}px`)
      }
    })
  }

  private handleClickOutside() {
    AppModule.CloseSideBar(false)
  }
}
